<template>
    <Popover v-slot="{ open, close }">
        <Float
            placement="bottom-start"
            composable
            enter="transition duration-200 ease-out"
            enter-from="opacity-0 translate-y-1"
            enter-to="opacity-100 translate-y-0"
            leave="transition duration-150 ease-in"
            leave-from="opacity-100 translate-y-0"
            leave-to="opacity-0 translate-y-1"
            :show="open"
        >
            <FloatReference>
                <PopoverButton type="button" :data-state="open ? 'open' : 'closed'" class="relative cursor-pointer">
                    <slot name="button"></slot>
                </PopoverButton>
            </FloatReference>

            <FloatContent>
                <PopoverPanel :data-state="[open ? 'open' : 'closed']" data-side="bottom">
                    <ui-popover class="w-fit">
                        <slot name="dropdown" :close="close"></slot>
                    </ui-popover>
                </PopoverPanel>
            </FloatContent>
        </Float>
    </Popover>
</template>

<script setup lang="ts">
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import { Float, FloatContent, FloatReference } from '@headlessui-float/vue';
</script>
